import React, { useState } from 'react';
import '../../styles/SiteNode.css';

const SiteNode = () => {
  const [formData, setFormData] = useState({
    siteName: '',
    siteAddress: '',
    siteImages: null,
    latitude: '',
    longitude: '',
    notes: '',
    type: 'Access',
    subType: 'Large Cabinet',
    manufacturer: 'Calix',
    cabinetModel: 'AXOS E9-2',
    cabinetNotes: '',
    locationNotes: '',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    // Handle form submission logic here
  };

  return (
    <form className="create-site-form" onSubmit={handleSubmit}>
      {/* <h2>Create Site</h2>
      <p>Setup the site in NEM</p> */}

      <div className="form-group">
        <label>Site Name</label>
        <input
          type="text"
          name="siteName"
          value={formData.siteName}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label>Site Address</label>
        <input
          type="text"
          name="siteAddress"
          value={formData.siteAddress}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label>Site Images</label>
        <input
          type="file"
          name="siteImages"
          accept="image/*"
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Latitude</label>
          <input
            type="text"
            name="latitude"
            value={formData.latitude}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Longitude</label>
          <input
            type="text"
            name="longitude"
            value={formData.longitude}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label>Notes</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
        ></textarea>
      </div>

      <div className="form-group fancy-select">
        <label>Type</label>
        <select name="type" value={formData.type} onChange={handleChange}>
          <option value="Core">Core</option>
          <option value="Metro">Metro</option>
          <option value="Access">Access</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="form-group">
        <label>Sub Type</label>
        <select name="subType" value={formData.subType} onChange={handleChange}>
          <option value="Building">Building</option>
          <option value="Colo">Colo</option>
          <option value="Large Cabinet">Large Cabinet</option>
          <option value="Small Cabinet">Small Cabinet</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="form-group">
        <label>Manufacturer</label>
        <select
          name="manufacturer"
          value={formData.manufacturer}
          onChange={handleChange}
        >
          <option value="Huswei">Huswei</option>
          <option value="Nokia">Nokia</option>
          <option value="Calix">Calix</option>
          <option value="ZTE">ZTE</option>
          <option value="Adtran">Adtran</option>
        </select>
      </div>

      <div className="form-group">
        <label>Cabinet Model</label>
        <select
          name="cabinetModel"
          value={formData.cabinetModel}
          onChange={handleChange}
        >
          <option value="AXOS E9-2">AXOS E9-2</option>
          <option value="AXOS E7-2">AXOS E7-2</option>
          <option value="AXOS E5">AXOS E5</option>
          <option value="AXOS E3">AXOS E3</option>
        </select>
      </div>

      <div className="form-group">
        <label>Cabinet Notes Updated</label>
        <textarea
          name="cabinetNotes"
          value={formData.cabinetNotes}
          onChange={handleChange}
        ></textarea>
      </div>

      <div className="form-group">
        <label>Location Notes</label>
        <textarea
          name="locationNotes"
          value={formData.locationNotes}
          onChange={handleChange}
        ></textarea>
      </div>

      <div className="form-actions">
        <button type="button" className="cancel-button">
          Cancel
        </button>
        <button type="submit" className="submit-button">
          Create Site
        </button>
      </div>
    </form>
  );
};

export default SiteNode;
